import { useEffect, useState } from "react";
import usePagination from "../../usePagination";
import { fetchMyCourse } from "../../../service/UserService/myCoursesService";
import { message } from "antd";

export const useMyCoursesData = (search) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const {
    currentPage,
    pageSize,
    setTotal,
    paginationConfig,
    setCurrentPage,
    handlePageChange,
  } = usePagination(0,10);

  const getCourses = async () => {
    setLoading(true);
    try {
      const res = await fetchMyCourse({
        page: currentPage,
        pageSize,
        search
      });
      setData(res?.data?.content || []);
      setTotal(res?.data?.totalElements || 0);
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCourses();
  }, [currentPage, pageSize, search]);

  useEffect(() => {
  setCurrentPage(0); // 👈 go back to first page
}, [search]);

  return {
    data,
    loading,
    paginationConfig,
    handlePageChange,
  };
};
